import React from "react";
import { keyframes, styled } from "goober";

import ExclamationIcon from "@/inline-assets/exclamation-mark.svg";

type ErrorOverlayProps = {
  message?: string;
};

export function ErrorOverlay({ message }: ErrorOverlayProps) {
  return (
    <ErrorWrapper>
      <ExclamationIcon />

      {message && <div>{message}</div>}
    </ErrorWrapper>
  );
}

const animFadeIn = () => keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const ErrorWrapper = styled("div")`
  position: absolute;
  inset: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--sp-2);

  color: var(--shade0);

  background: var(--shade10-75);

  cursor: not-allowed;

  animation: ${animFadeIn} var(--transition);

  svg {
    flex: 1;

    max-width: var(--sp-8);
    max-height: var(--sp-8);
  }

  div {
    flex: 1;

    padding: var(--sp-1_5) var(--sp-2);

    background: var(--shade8);
    border-radius: var(--br);
  }
`;
